'use strict';

import React, { useState } from 'react';
import PageFrame, { PHONE } from '../becomeApplicantV2/PageFrame';
import LimitLoanV2Process from './limitLoanV2Process';
import { parseLimitParams } from './limitContext';

/**
 * New luottolimiitti (credit limit) application flow (/avaa-luottolimiitti).
 * Same page frame, components and styles as the other v2 forms; the live limitLoan/
 * flow is not touched.
 */

const afterForm = (
  <>
    <p>Oletko hakemassa yrityslainaa? Voit siirtyä yrityslainahakemukseen <a href="/hae-yrityslainaa">tästä</a>.</p>
    <p>Jos olet jo asiakkaamme, voit kirjautua sivuillesi <a href="https://app.kasvurahoitus.fi/login">tästä</a>. Asiakaspalvelumme on tavoitettavissa puhelimitse numerossa <a href={PHONE.href}>{PHONE.intl}</a> (ark. klo 9-16) ja sähköpostitse osoitteessa <a href="mailto:yrityslaina@kasvurahoitus.fi">yrityslaina@kasvurahoitus.fi</a>.</p>
  </>
);

export default function LimitLoanV2({ match, history }) {
  const context = parseLimitParams(match, history && history.location ? history.location.search : '');
  const [step, setStep] = useState(1);
  return (
    <PageFrame
      promo={<>Nyt uusiin luottolimiitteihin <strong>kolme (3) ensimmäistä kuukautta</strong> ilman pääomanlyhennyksiä.</>}
      contactEmail="yrityslaina@kasvurahoitus.fi"
      afterForm={step === 1 ? afterForm : null}
    >
      <LimitLoanV2Process context={context} onStepChange={setStep} />
    </PageFrame>
  );
}
